module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-download-5bb29a21bf3d48949b9d3306d64bc559.png";